export default "__VITE_ASSET__BZDc9CtI__"